import { useFormikContext } from 'formik'
import { Checkbox } from '@farewill/ui'

// Set this up as a generic type to allow access to underlying data
// it is set to `unknown` by default which causes type errors
type FormikContextType = Record<string, string[]>

const GroupedCheckbox = ({
  value,
  label,
  groupName,
}: {
  value: string
  label: string
  // currently these are hardcoded for reference, but would be nicer to lookup from a declared type
  // but have been unabel to get that to work.
  groupName: 'products' | 'brandIds'
}) => {
  const { setFieldValue, values } = useFormikContext<FormikContextType>()

  const handleUpdatingList = () => {
    if (values[groupName].includes(value)) {
      setFieldValue(
        groupName,
        values[groupName].filter((current: string) => current !== value)
      )
    } else {
      setFieldValue(groupName, [...values[groupName], value])
    }
  }

  return (
    <Checkbox
      label={label}
      size="S"
      onChange={handleUpdatingList}
      checked={values[groupName].includes(value)}
    />
  )
}

export default GroupedCheckbox
